// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__1bZpg","footer":"ModalCreateQualiphyProcedure_footer__2GfxY","additionData":"ModalCreateQualiphyProcedure_additionData__-_2Wz"};